import styled, { css } from "styled-components";

const CssActive = css`
    border: 1px solid transparent;
    background: #fff7;

    &:not(:disabled):hover {
        cursor: default;
    }
`;

const CssPassive = css`
    border: 1px solid #fff7;
    opacity: .6;

    &:not(:disabled):hover {
        background: #fff4;
        cursor: pointer;
        opacity: 1;
    }
`;

const Styled = styled.button`
    align-items: center;
    cursor: default;
    display: flex;
    flex-direction: row;
    font-family: var(--font-mono), monospace;
    gap: 32px;
    justify-content: space-between;
    overflow: hidden;
    position: relative;
    transition: background 200ms;

    &:first-of-type {
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
    }

    &:last-of-type {
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
    }

    & > div:first-of-type {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        padding-right: 12px;
        position: relative;
    }

    &:not(:disabled):hover {
        cursor: pointer;

        & > * {
            opacity: 1;
        }
    }

    background: transparent;
    color: #fff;
    padding: 12px 16px;

    & > div {
        display: flex;
        flex-direction: column;
        gap: 4px;
        position: relative;
    }

    span {
        display: block;
    }

    .label {
        font-size: 1.6rem;
    }

    .hint {
        font-size: .8rem;
        max-width: 260px;
        text-align: left;
    }

    ${ ({ active }) => active ? CssActive : CssPassive }

    &:disabled {
        opacity: .2;
    }
`;

export default function ParameterType(props) {
    const { hint, label, ...restProps } = props;

    return (
        <Styled { ...restProps }>
            <div>
                <span className="label">{ label }</span>
                <span className="hint">{ hint }</span>
            </div>
        </Styled>
    );
}
